export const PLATFORM_POST_LIMITS = {
  instagram: 2200,
  facebook: 63206,
  linkedin: 3000,
  twitter: 280, // free: 280 premium: 25000
  threads: 500,
};

export const PLATFORM_SHORT_TEXT = ["instagram", "twitter", "threads"];

export const PLATFORM_LONG_TEXT = ["facebook", "linkedin"];

export const PLATFORM_TITLE = {
  instagram: "Instagram",
  facebook: "Facebook",
  linkedin: "LinkedIn",
  twitter: "X/Twitter",
  threads: "Threads",
};

export const PLATFORM_IMAGE = {
  instagram: "/static/images/instagram.png",
  facebook: "/static/images/facebook.png",
  linkedin: "/static/images/linkedin.png",
  twitter: "/static/images/x.png",
  threads: "/static/images/threads.png",
};

export const PLATFORM_BACKGROUND_COLOR = {
  instagram: "bg-pink-100",
  facebook: "bg-blue-100",
  linkedin: "bg-sky-100",
  twitter: "bg-slate-200",
  threads: "bg-gray-200",
};

export const PLATFORM_TEXT_COLOR = {
  instagram: "bg-pink-500",
  facebook: "bg-blue-500",
  linkedin: "bg-sky-500",
  twitter: "bg-slate-500",
  threads: "bg-gray-500",
};

export const PLATFORM_TEXT_COLOR_HEX = {
  instagram: "#EC4899",
  facebook: "#3B82F6",
  linkedin: "#0EA5E9",
  twitter: "#64748B",
  threads: "#6B7280",
};
